import React from 'react'

const AlertIcon = ({ size = 15, className, color = "#dc2626", strokeWidth = "2", ...props }) => {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" className={className} width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path 
        d="M12 6V10" 
        stroke={color} 
        strokeWidth={strokeWidth} 
        strokeLinecap="round"
      />
      <path 
        d="M12 14H12.01" 
        stroke={color} 
        strokeWidth={strokeWidth} 
        strokeLinecap="round"
      />
    </svg>
  )
}

export default AlertIcon
